<script setup lang="ts">
import ImageCarousel from './ImageCarousel.vue';
import SignUpForm from './SignUpForm.vue';
</script>

<template>
  <div class="flex min-h-screen bg-[#0A0A0B]">
    <!-- Left Panel - Visual Storytelling -->
    <div class="hidden lg:flex lg:w-1/2 bg-[#111113] relative overflow-hidden">
      <ImageCarousel />
    </div>

    <!-- Right Panel - Sign Up Form -->
    <div class="flex-1 flex items-center justify-center p-6 md:p-12 bg-[#0A0A0B]">
      <div class="w-full max-w-md">
        <SignUpForm />
      </div>
    </div>
  </div>
</template>
